// Copyright (C) 2023 TANNER AG

import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import useAsset from "../../../hooks/useasset";
import useFallbackImage from "../../../hooks/useFallbackImage";
import RichText from "../../../components/content/RichText";


type Props = {
    title?: string;
    thumbnail?: string;
    description?: string;
    originalPath?: string;
};

const CodeDetailsRelatedContentPodcast: React.FC<Props> = ({ title, thumbnail, description ,originalPath}) => {
    const navigate = useNavigate();
    const { createImageUrl } = useAsset();
    const { fallbackImage } = useFallbackImage();

    return (
        <Box onClick={() => navigate(`${originalPath}`)} sx={{ cursor: "pointer", backgroundColor:"background.paper", padding:1 }}>
            <Grid container>
                <Grid item xs={4}>
                    <Box
                        component="img"
                        alt="News thumbnail"
                        src={thumbnail ? createImageUrl(thumbnail) : fallbackImage}
                        sx={{ width: "100%" }}
                    />
                </Grid>
                <Grid item xs={8} paddingLeft={2.5}>
                    <Typography variant="h5">{title}</Typography>
                    <RichText
                        html={description}
                        sx={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "-webkit-box",
                            WebkitLineClamp: "3",
                            WebkitBoxOrient: "vertical"
                        }}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

export default CodeDetailsRelatedContentPodcast;
